import { vars } from "@imwebme/clay-token";
import { Label } from "../..";
import { Flex } from "../../utilities/Flex";
import type { CheckboxGroupProps } from "./CheckboxGroup.types";

export const CheckboxGroup = ({
  label,
  legend,
  direction = "column",
  sx,
  children,
}: CheckboxGroupProps) => {
  const deprecatedLegend = legend || label;

  return (
    <Flex.Column as="fieldset" gap={vars.spacing[1]} sx={sx}>
      {deprecatedLegend && typeof deprecatedLegend === "string" ? (
        <Label as="legend" text={deprecatedLegend} />
      ) : (
        deprecatedLegend
      )}

      <Flex.Column flexDirection={direction} gap={vars.spacing[direction === "column" ? 1 : 6]}>
        {children}
      </Flex.Column>
    </Flex.Column>
  );
};
